'use strict';

import { resetForm } from '../../_assets/abbott/js/_dashboard';
import Loader from '../../_modules/loader/loader';

let loader;

export default class BackToLink {
    constructor() {
		
		// use it for Release A
		// to review "clear all" and "back to dashboard link" by using commented out code in dashboard.js
		$('.js-back-to-dashboard-ajax').on('click', function(e){
			e.preventDefault();
			loader = new Loader();

			loader.fadeIn();
			
			$('.main-nav').slideDown({
                duration: 500,
                easing: 'easeInOutExpo'
            });

            $('.multi-steps-nav').slideUp({
                duration: 500,
                easing: 'easeInOutExpo'
            });
			
			setTimeout(function(){ window.location.reload(); }, 250); 
		});


    }
}
